import './prize-tiles.scss';

import { A11y, Navigation, Scrollbar } from 'swiper/modules';

class PrizeTiles {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-prizetiles'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$prizeTiles = $element;
        this.$prizeTilesSlider = this.$prizeTiles.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$prizeTilesSlides = this.$prizeTilesSlider.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.prizeTilesSlider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$prizeTilesSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
        // this.initialize();
    }

    initialize () {
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$prizeTilesSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1024 && this.$prizeTilesSlides.length > 2) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth < 1440 && this.$prizeTilesSlides.length > 3) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else if (window.innerWidth >= 1440 && this.$prizeTilesSlides.length > 4) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.prizeTilesSlider = new this.Slider(this.$prizeTilesSlider, {
            modules: [A11y, Navigation, Scrollbar],
            speed: 500,
            slidesPerView: 'auto',
            buttonAdditionalClass: 'swiper-button-secondary',
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            scrollbar: true,
            breakpoints: {
                768: {
                    centeredSlides: false,
                    centeredSlidesBounds: false
                }
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.prizeTilesSlider !== 'undefined' && this.prizeTilesSlider !== null) {
            this.prizeTilesSlider.destroy();
        }
    }
}

export { PrizeTiles };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$prizeTiles = $context.querySelectorAll('[data-prizetiles="root"]');
        for (let i = 0; i < $$prizeTiles.length; i++) {
            const $prizeTiles = $$prizeTiles[i];

            const prizeTilesAPI = new PrizeTiles($prizeTiles);
            $prizeTiles.API = prizeTilesAPI;
        }
    }
});
